/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenderComposition } from './GenderComposition';
import {
    GenderCompositionFromJSON,
    GenderCompositionFromJSONTyped,
    GenderCompositionToJSON,
    GenderCompositionToJSONTyped,
} from './GenderComposition';
import type { GetSeasonBaseResponse } from './GetSeasonBaseResponse';
import {
    GetSeasonBaseResponseFromJSON,
    GetSeasonBaseResponseFromJSONTyped,
    GetSeasonBaseResponseToJSON,
    GetSeasonBaseResponseToJSONTyped,
} from './GetSeasonBaseResponse';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { GetTuitionDiscountResponse } from './GetTuitionDiscountResponse';
import {
    GetTuitionDiscountResponseFromJSON,
    GetTuitionDiscountResponseFromJSONTyped,
    GetTuitionDiscountResponseToJSON,
    GetTuitionDiscountResponseToJSONTyped,
} from './GetTuitionDiscountResponse';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ClassDayResponse } from './ClassDayResponse';
import {
    ClassDayResponseFromJSON,
    ClassDayResponseFromJSONTyped,
    ClassDayResponseToJSON,
    ClassDayResponseToJSONTyped,
} from './ClassDayResponse';
import type { GetClassRoomResponse } from './GetClassRoomResponse';
import {
    GetClassRoomResponseFromJSON,
    GetClassRoomResponseFromJSONTyped,
    GetClassRoomResponseToJSON,
    GetClassRoomResponseToJSONTyped,
} from './GetClassRoomResponse';
import type { GetLocationResponse } from './GetLocationResponse';
import {
    GetLocationResponseFromJSON,
    GetLocationResponseFromJSONTyped,
    GetLocationResponseToJSON,
    GetLocationResponseToJSONTyped,
} from './GetLocationResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetTeacherBaseResponse } from './GetTeacherBaseResponse';
import {
    GetTeacherBaseResponseFromJSON,
    GetTeacherBaseResponseFromJSONTyped,
    GetTeacherBaseResponseToJSON,
    GetTeacherBaseResponseToJSONTyped,
} from './GetTeacherBaseResponse';

/**
 * 
 * @export
 * @interface GetClassResponse
 */
export interface GetClassResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetClassResponse
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    slug: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    imageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    allowOnlineRegistration: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetClassResponse
     */
    classStartDate: Date;
    /**
     * 
     * @type {any}
     * @memberof GetClassResponse
     */
    classEndDate: any | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetClassResponse
     */
    minAge: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetClassResponse
     */
    maxAge: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    classStartTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetClassResponse
     */
    classEndTime: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetClassResponse
     */
    maxNumberOfStudents: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    hideOnLiveSchedule: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    recital: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetClassResponse
     */
    tuition: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetClassResponse
     */
    registrationFee: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {GenderComposition}
     * @memberof GetClassResponse
     */
    genderComposition: GenderComposition | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    requiresApproval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    hasWaitList: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    isContinuous: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetClassResponse
     */
    currentNumberOfStudents: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    billSeparately: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    applySeasonRegistrationFee: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetClassResponse
     */
    tuitionRatePlanId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    prorateTuition: boolean | null;
    /**
     * 
     * @type {GetClassRoomResponse}
     * @memberof GetClassResponse
     */
    classRoom: GetClassRoomResponse | null;
    /**
     * 
     * @type {GetSeasonBaseResponse}
     * @memberof GetClassResponse
     */
    season: GetSeasonBaseResponse | null;
    /**
     * 
     * @type {GetLocationResponse}
     * @memberof GetClassResponse
     */
    location: GetLocationResponse | null;
    /**
     * 
     * @type {Array<ClassDayResponse>}
     * @memberof GetClassResponse
     */
    classDays: Array<ClassDayResponse>;
    /**
     * 
     * @type {Array<GetTeacherBaseResponse>}
     * @memberof GetClassResponse
     */
    teachers: Array<GetTeacherBaseResponse>;
    /**
     * 
     * @type {Array<GetTuitionDiscountResponse>}
     * @memberof GetClassResponse
     */
    tuitionDiscounts: Array<GetTuitionDiscountResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    isFeatured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassResponse
     */
    offersMakeup?: boolean;
}



/**
 * Check if a given object implements the GetClassResponse interface.
 */
export function instanceOfGetClassResponse(value: object): value is GetClassResponse {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('allowOnlineRegistration' in value) || value['allowOnlineRegistration'] === undefined) return false;
    if (!('classStartDate' in value) || value['classStartDate'] === undefined) return false;
    if (!('classEndDate' in value) || value['classEndDate'] === undefined) return false;
    if (!('minAge' in value) || value['minAge'] === undefined) return false;
    if (!('maxAge' in value) || value['maxAge'] === undefined) return false;
    if (!('classStartTime' in value) || value['classStartTime'] === undefined) return false;
    if (!('classEndTime' in value) || value['classEndTime'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('hideOnLiveSchedule' in value) || value['hideOnLiveSchedule'] === undefined) return false;
    if (!('recital' in value) || value['recital'] === undefined) return false;
    if (!('tuition' in value) || value['tuition'] === undefined) return false;
    if (!('registrationFee' in value) || value['registrationFee'] === undefined) return false;
    if (!('genderComposition' in value) || value['genderComposition'] === undefined) return false;
    if (!('requiresApproval' in value) || value['requiresApproval'] === undefined) return false;
    if (!('hasWaitList' in value) || value['hasWaitList'] === undefined) return false;
    if (!('isContinuous' in value) || value['isContinuous'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('currentNumberOfStudents' in value) || value['currentNumberOfStudents'] === undefined) return false;
    if (!('billSeparately' in value) || value['billSeparately'] === undefined) return false;
    if (!('applySeasonRegistrationFee' in value) || value['applySeasonRegistrationFee'] === undefined) return false;
    if (!('tuitionRatePlanId' in value) || value['tuitionRatePlanId'] === undefined) return false;
    if (!('prorateTuition' in value) || value['prorateTuition'] === undefined) return false;
    if (!('classRoom' in value) || value['classRoom'] === undefined) return false;
    if (!('season' in value) || value['season'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('classDays' in value) || value['classDays'] === undefined) return false;
    if (!('teachers' in value) || value['teachers'] === undefined) return false;
    if (!('tuitionDiscounts' in value) || value['tuitionDiscounts'] === undefined) return false;
    return true;
}

export function GetClassResponseFromJSON(json: any): GetClassResponse {
    return GetClassResponseFromJSONTyped(json, false);
}

export function GetClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'name': json['name'],
        'slug': json['slug'],
        'imageUrl': json['imageUrl'],
        'description': json['description'],
        'allowOnlineRegistration': json['allowOnlineRegistration'],
        'classStartDate': (new Date(json['classStartDate'])),
        'classEndDate': json['classEndDate'],
        'minAge': BalanceUnitStatementEntryDebitFromJSON(json['minAge']),
        'maxAge': BalanceUnitStatementEntryDebitFromJSON(json['maxAge']),
        'classStartTime': json['classStartTime'],
        'classEndTime': json['classEndTime'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'hideOnLiveSchedule': json['hideOnLiveSchedule'],
        'recital': json['recital'],
        'tuition': BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'registrationFee': BalanceUnitStatementEntryDebitFromJSON(json['registrationFee']),
        'genderComposition': GenderCompositionFromJSON(json['genderComposition']),
        'requiresApproval': json['requiresApproval'],
        'hasWaitList': json['hasWaitList'],
        'isContinuous': json['isContinuous'],
        'isActive': json['isActive'],
        'currentNumberOfStudents': ApiUserTasksGetPageParameterFromJSON(json['currentNumberOfStudents']),
        'billSeparately': json['billSeparately'],
        'applySeasonRegistrationFee': json['applySeasonRegistrationFee'],
        'tuitionRatePlanId': ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'prorateTuition': json['prorateTuition'],
        'classRoom': GetClassRoomResponseFromJSON(json['classRoom']),
        'season': GetSeasonBaseResponseFromJSON(json['season']),
        'location': GetLocationResponseFromJSON(json['location']),
        'classDays': ((json['classDays'] as Array<any>).map(ClassDayResponseFromJSON)),
        'teachers': ((json['teachers'] as Array<any>).map(GetTeacherBaseResponseFromJSON)),
        'tuitionDiscounts': ((json['tuitionDiscounts'] as Array<any>).map(GetTuitionDiscountResponseFromJSON)),
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
        'offersMakeup': json['offersMakeup'] == null ? undefined : json['offersMakeup'],
    };
}

export function GetClassResponseToJSON(json: any): GetClassResponse {
    return GetClassResponseToJSONTyped(json, false);
}

export function GetClassResponseToJSONTyped(value?: GetClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'name': value['name'],
        'slug': value['slug'],
        'imageUrl': value['imageUrl'],
        'description': value['description'],
        'allowOnlineRegistration': value['allowOnlineRegistration'],
        'classStartDate': value['classStartDate'].toISOString().substring(0,10),
        'classEndDate': value['classEndDate'],
        'minAge': BalanceUnitStatementEntryDebitToJSON(value['minAge']),
        'maxAge': BalanceUnitStatementEntryDebitToJSON(value['maxAge']),
        'classStartTime': value['classStartTime'],
        'classEndTime': value['classEndTime'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'hideOnLiveSchedule': value['hideOnLiveSchedule'],
        'recital': value['recital'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'registrationFee': BalanceUnitStatementEntryDebitToJSON(value['registrationFee']),
        'genderComposition': GenderCompositionToJSON(value['genderComposition']),
        'requiresApproval': value['requiresApproval'],
        'hasWaitList': value['hasWaitList'],
        'isContinuous': value['isContinuous'],
        'isActive': value['isActive'],
        'currentNumberOfStudents': ApiUserTasksGetPageParameterToJSON(value['currentNumberOfStudents']),
        'billSeparately': value['billSeparately'],
        'applySeasonRegistrationFee': value['applySeasonRegistrationFee'],
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'prorateTuition': value['prorateTuition'],
        'classRoom': GetClassRoomResponseToJSON(value['classRoom']),
        'season': GetSeasonBaseResponseToJSON(value['season']),
        'location': GetLocationResponseToJSON(value['location']),
        'classDays': ((value['classDays'] as Array<any>).map(ClassDayResponseToJSON)),
        'teachers': ((value['teachers'] as Array<any>).map(GetTeacherBaseResponseToJSON)),
        'tuitionDiscounts': ((value['tuitionDiscounts'] as Array<any>).map(GetTuitionDiscountResponseToJSON)),
        'isFeatured': value['isFeatured'],
        'offersMakeup': value['offersMakeup'],
    };
}

